// src/security/keycloakService.ts
import type { KeycloakTokenParsed } from 'keycloak-js'
import { keycloakInstance } from '@/security/instance'

type CallbackFunction = (
  input: { user?: KeycloakTokenParsed },
  error?: Error | unknown
) => void

function currentAreaBase(): '/expert' | '/guest' {
  return window.location.pathname.startsWith('/expert') ? '/expert' : '/guest'
}

const Login = async (onAuthenticatedCallback: CallbackFunction) => {
  try {
    if (keycloakInstance.authenticated) {
      const { tokenParsed: user } = keycloakInstance
      onAuthenticatedCallback({ user })
      return
    }

    await keycloakInstance.init({
      onLoad: 'login-required',
      pkceMethod: 'S256',
      checkLoginIframe: false,
      silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
    })

    const { tokenParsed: user } = keycloakInstance
    onAuthenticatedCallback({ user })
  } catch (err) {
    console.error('Failed to initialize adapter:', err)
    onAuthenticatedCallback({}, err)
  }
}

const Logout = async () => {
  try {
    const redirectUri = `${window.location.origin}${currentAreaBase()}`
    await keycloakInstance.logout({ redirectUri })
  } catch (err) {
    console.error('Failed to logout:', err)
    window.location.href = `${window.location.origin}${currentAreaBase()}`
  }
}

export const KeyCloakService = {
  CallLogin: Login,
  Logout,
}

export default KeyCloakService
